import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../../../../../common/html/checkbox'
import { Element } from '../../../../../../../common/html/element'
import { SelectCustom } from '../../../../../../../common/selectCustom'
import { selectTypePeriod } from '../../../../../store/slice'
import { selectListFilterTimeHistoricalChange } from '../../../../store/slice'
import { formatListFilterTime } from '../helper'
import s from './index.module.scss'

const CompareFilter = ({
  filterTime,
  setFilterTime = () => {},
  isCompare,
  setIsCompare = () => {},
}) => {
  const timeFrequency = useSelector(selectTypePeriod)
  const listFilterTime = useSelector(selectListFilterTimeHistoricalChange)
  const options = formatListFilterTime(listFilterTime, timeFrequency)

  const { from, to } = filterTime

  useEffect(() => {
    if (options.length > 0) {
      const newFrom = options[1]
      const newTo = options[0]
      setFilterTime({
        from: newFrom,
        to: newTo,
        timeFrequency,
      })
    }
  }, [timeFrequency, JSON.stringify(options)])

  const handleChooseFrom = (item) => {
    setFilterTime({
      from: item,
      to: to,
      timeFrequency,
    })
  }

  const handleChooseTo = (item) => {
    setFilterTime({
      from: from,
      to: item,
      timeFrequency,
    })
  }

  return (
    <Element className={s.container}>
      <Checkbox
        title="riskComponentAnalysis.compareData"
        isI18n
        checked={isCompare}
        isCheckOnClickText
        style={{
          paddingLeft: 6,
        }}
        onChange={() => {
          setIsCompare((prev) => !prev)
        }}
      />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          opacity: isCompare ? 1 : 0.5,
          pointerEvents: isCompare ? 'auto' : 'none',
        }}
      >
        <Translate value="riskComponentAnalysis.comparisonPeriod" />
        <SelectCustom
          activeItem={!isCompare || !to ? {} : to}
          data={options}
          chooseItem={handleChooseTo}
          style={{
            marginRight: 4,
            fontSize: 12,
            padding: '4px 12px',
            minWidth: 70,
          }}
        />
        <Translate value="riskComponentAnalysis.basePeriod" />
        <SelectCustom
          activeItem={!isCompare || !from ? {} : from}
          data={options}
          chooseItem={handleChooseFrom}
          style={{
            marginRight: 4,
            fontSize: 12,
            padding: '4px 12px',
            minWidth: 70,
          }}
        />
      </div>
    </Element>
  )
}

export default CompareFilter
